module.exports = __webpack_public_path__ + "static/media/search.71cb7135.png";